import { DEFAULT_FEATURES_VALUE, FeatureToggles } from '@/composables/useFeatureToggle';
import { router } from '@/router';

export const isFeatureEnabled = (feature: FeatureToggles) => {
  const currentRoute = router.currentRoute?.value;
  const query = currentRoute?.query;
  // Check URL query param OR fall back to default value (same logic as useFeatureToggle)
  return query?.[feature] === 'true' || DEFAULT_FEATURES_VALUE[feature];
};
